import { Link, useLocation } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

export default function Footer() {
  const { pathname } = useLocation();
  if (pathname === "/checkout") return null;
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-columns">
          <div className="footer-visit">
            <h2>Company information</h2>
            <a
              className="footer-email"
              href={`mailto:${siteConfig.contact.email}`}
            >
              {siteConfig.contact.email}
            </a>
            <p>
              {siteConfig.companyName}
              <br />
              {siteConfig.contact.address}
            </p>
          </div>
          <div>
            <h2>Learn more</h2>
            <nav aria-label="About velvetvogue">
              <Link to="/about">About {siteConfig.brandTitle}</Link>
              <Link to="/about#craft">Our approach</Link>
              <Link to="/shop">Our collections</Link>
              <Link to="/contact">Contact us</Link>
            </nav>
          </div>
          <div>
            <h2>Policies</h2>
            <nav aria-label="Store policies">
              <Link to="/shipping">Shipping &amp; Handling</Link>
              <Link to="/shipping#delivery-timing">Delivery Timing</Link>
              <Link to="/returns">Return Policy</Link>
              <Link to="/faqs">FAQs</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/cookies">Cookie Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </nav>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-locale">
            <span>Hong Kong (USD $)</span>
            <span>English</span>
          </div>
          <div
            className="footer-payments"
            aria-label="Supported payment methods"
          >
            <span>Secure payments</span>
            <b>VISA</b>
            <b>Mastercard</b>
            <b>AMEX</b>
            <b>Apple Pay</b>
            <b>Google Pay</b>
          </div>
          <p>
            © {new Date().getFullYear()} · {siteConfig.brandTitle}
          </p>
          <span className="footer-signature">Designed in Hong Kong</span>
        </div>
      </div>
    </footer>
  );
}
